import React from "react";
import { Box, TableCell, Typography } from "@material-ui/core";
import HaklaiAddPillButton from "./HaklaiAddPillButton";

// Plus slot (28) + gap (12) + "ניכויים מבנה עיבוד" beside the מסחרי badge.
// Longer asset names run into the table edge.
export const HAKLAI_SECTION_LABEL_COLUMN_WIDTH = 198;

const SECTION_LABEL_CELL_STYLE = {
  width: HAKLAI_SECTION_LABEL_COLUMN_WIDTH,
  minWidth: HAKLAI_SECTION_LABEL_COLUMN_WIDTH,
  maxWidth: HAKLAI_SECTION_LABEL_COLUMN_WIDTH
};

/**
 * Visual-right column for a Haklai section's first row.
 * The plus stays on the right. The title starts beside it, on the table's right edge.
 * Later rows render the same cell empty so the column stays aligned.
 */
const HaklaiSectionLabelCell = ({ title = "", badge = null, addButton = null }) => (
  <TableCell className="haklai-section-label-cell" style={SECTION_LABEL_CELL_STYLE}>
    {title ? (
      <Box className="haklai-section-label">
        <Box className="haklai-section-label-plus" aria-hidden={addButton ? undefined : "true"}>
          {addButton ? (
            <HaklaiAddPillButton
              classes={addButton.classes}
              mode={addButton.mode}
              disabled={addButton.disabled}
              onClick={addButton.onClick}
              label={addButton.label}
              readyLabel={addButton.readyLabel}
              unavailableLabel={addButton.unavailableLabel}
            />
          ) : null}
        </Box>
        <Typography component="div" dir="rtl" className="haklai-section-label-text">
          {badge}
          <span>{title}</span>
        </Typography>
      </Box>
    ) : null}
  </TableCell>
);

export default React.memo(HaklaiSectionLabelCell);
